module.exports = "fragment TransportService on TransportServiceType{id rowId title logo maxWeight allianceCustomers}"